import baseUrl from "./base"
import {postRequest, postRequestCustomHeaders, getRequest, getRequestCustomHeaders} from "./common"


const chatApi = {
    //獲取聊天群組的詳細信息
    "getGroupinfo": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.chatHttp}/userGroup/getGroupinfo`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                roomId: null,  //群組id
            }
        }
    },
    //獲取用户聊天群組
    "getUserGroupinfo": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.chatHttp}/userInfo/getUserGroupinfo`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                UserLogin: null,  //群組id
            }
        }
    },
    //新建聊天群组
    "openPersonalRoom": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.chatHttp}/userGroup/openPersonalRoom`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                token: null,
                cmd: 22,
                isFriend: true,
                users: [
                    { account: null }
                ],
                publicRoom: false,
                groupType: 0,
                anonymous: false,
                obId:""
            }
        }
    },
    //獲取聊天群組的檔案
    "getChatFileList": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}chat/getChatFileList`, data, callback, failCallback, errorCallback)
        },
            getParams: () => {
            return {
                roomid: null,  //群組id
            }
        }
    },

}

export default chatApi